<template lang="html">
  <section class="wcc section add-to-homescreen" v-if="addToHomescreen && event">
    <Prompt v-hammer:tap="prompt"></Prompt>
  </section>
</template>
<script>

  import Prompt from '../Prompt.vue'
  export default {
    data() {
      return {
        event: null
      }
    },
    methods: {
      prompt() {
        this.event.prompt()
        this.event.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          this.event = null;
        })
      }
    },
    computed: {
      addToHomescreen() {
        return this.$store.state.addToHomescreen.show
      },
    },
    mounted() {
      console.log('mounted')
      window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault()
        this.event = event
        
      })
      console.log('after event')
    },
    components: {
      Prompt
    },
  }
</script>
<style lang="scss">
</style>